import
Mousetrap from 'mousetrap';

import { environment } from '../../../../environments/environment';
import { EmbeddedType } from '../../../core/store/article/article-content.model';
import { generateShortId } from '../../shared-functions';
import { getLocaleCode } from '../get-editor-locale';
import { customCommandsTranslations } from './custom-commands';
import { MentionKeys } from '../../../core/api/tribute/tribute.service';
import { getStaticProcessedEmoticons } from './emoticons';


declare const $: any;

const theme = getChosenTheme()

// Custom Icons SVG path
export const customSvgBrightcove = '<path d="m 10.6,17.5 c -0.8,0 -1.5,0 -2.3,0 -0.6,0 -0.8,-0.4 -0.5,-0.9 0.8,-1.3 1.5,-2.6 2.3,-4 0.3,-0.5 0.8,-0.8 1.4,-0.8 1.5,0 3,0 4.5,0 0.7,0 0.9,0.4 0.6,1 -0.7,1.3 -1.5,2.6 -2.2,3.9 -0.3,0.5 -0.8,0.8 -1.4,0.8 -0.9,0 -1.7,0 -2.4,0 z M 21,11.9 c 0.8,0 1.6,0 2.4,0 0.6,0 0.8,0.4 0.5,0.8 -0.8,1.4 -1.6,2.7 -2.4,4.1 -0.3,0.5 -0.7,0.7 -1.2,0.7 -1.6,0 -3.2,0 -4.7,0 -0.5,0 -0.8,-0.4 -0.5,-0.9 0.8,-1.3 1.5,-2.7 2.3,-4 0.3,-0.5 0.8,-0.8 1.4,-0.8 0.7,0.1 1.4,0.1 2.2,0.1 z M 9.7,11.7 c 0,0.2 -0.1,0.5 -0.2,0.7 C 8.7,13.7 8,15 7.2,16.3 6.9,16.8 6.4,16.8 6.1,16.3 5.3,15 4.6,13.6 3.8,12.3 3.5,11.8 3.5,11.3 3.8,10.8 4.6,9.4 5.4,8.1 6.2,6.7 6.4,6.3 6.9,6.3 7.1,6.7 8,8.1 8.8,9.6 9.6,11 c 0.1,0.2 0.1,0.4 0.1,0.7 z M 6.1,5.3 C 6.1,5.6 6,5.9 5.9,6.1 5.1,7.4 4.4,8.7 3.6,10 3.3,10.5 2.8,10.5 2.6,10 1.8,8.8 1,7.4 0.3,6.1 0,5.5 0,4.9 0.3,4.3 1,3.1 1.8,1.8 2.5,0.5 2.8,0 3.3,0 3.6,0.6 4.3,1.9 5.1,3.2 5.8,4.5 6,4.7 6.1,5 6.1,5.3 Z m 7.6,5.9 c -0.7,0 -1.4,0 -2.1,0 -0.7,0 -1.3,-0.3 -1.6,-0.9 C 9.2,9 8.5,7.8 7.8,6.5 7.5,5.9 7.7,5.5 8.4,5.5 c 1.5,0 2.9,0 4.4,0 0.7,0 1.2,0.3 1.6,0.9 0.7,1.3 1.5,2.5 2.2,3.8 0.3,0.6 0.1,1 -0.5,1 -0.9,0 -1.7,0 -2.4,0 z M 21,23.9 c -0.8,0 -1.5,0 -2.3,0 -0.6,0 -1,-0.3 -1.3,-0.8 -0.8,-1.3 -1.5,-2.7 -2.3,-4 -0.3,-0.5 -0.1,-0.9 0.5,-0.9 1.6,0 3.2,0 4.7,0 0.6,0 1,0.3 1.3,0.8 0.8,1.3 1.5,2.7 2.3,4 0.3,0.5 0,0.8 -0.5,0.8 -0.8,0.1 -1.6,0.1 -2.4,0.1 z" id="path309" />';
export const customSvgCloseCT = '<path d="m 12,11.3 c -0.7,0 -1.2,0.6 -1.2,1.2 v 1.2 h 2.4 v -1.2 c 0,-0.6 -0.5,-1.2 -1.2,-1.2 z m 0,0 c -0.7,0 -1.2,0.6 -1.2,1.2 v 1.2 h 2.4 v -1.2 c 0,-0.6 -0.5,-1.2 -1.2,-1.2 z m 0,0 c -0.7,0 -1.2,0.6 -1.2,1.2 v 1.2 h 2.4 v -1.2 c 0,-0.6 -0.5,-1.2 -1.2,-1.2 z m 0,0 c -0.7,0 -1.2,0.6 -1.2,1.2 v 1.2 h 2.4 v -1.2 c 0,-0.6 -0.5,-1.2 -1.2,-1.2 z m 8.4,-8.9 h -5 C 14.7,0.5 12.7,-0.4 10.8,0.3 9.8,0.6 9,1.4 8.6,2.4 h -5 C 2.3,2.4 1.2,3.5 1.2,4.8 v 16.9 c 0,1.3 1.1,2.4 2.4,2.4 h 16.8 c 1.3,0 2.4,-1.1 2.4,-2.4 V 4.8 c 0,-1.4 -1.1,-2.4 -2.4,-2.4 z m -8.4,0 c 0.7,0 1.2,0.6 1.2,1.2 0,0.7 -0.6,1.2 -1.2,1.2 -0.7,0 -1.2,-0.5 -1.2,-1.2 0,-0.7 0.5,-1.2 1.2,-1.2 z M 7.2,13.7 h 1.2 v -1.2 c 0,-2 1.7,-3.6 3.7,-3.5 1.9,0 3.5,1.6 3.5,3.5 v 1.2 h 1.2 v 4.8 H 7.2 Z m 13.2,8 H 3.6 v -1.1 h 16.8 v 1.1 z M 12,11.3 c -0.7,0 -1.2,0.6 -1.2,1.2 v 1.2 h 2.4 v -1.2 c 0,-0.6 -0.5,-1.2 -1.2,-1.2 z m 0,0 c -0.7,0 -1.2,0.6 -1.2,1.2 v 1.2 h 2.4 v -1.2 c 0,-0.6 -0.5,-1.2 -1.2,-1.2 z m 0,0 c -0.7,0 -1.2,0.6 -1.2,1.2 v 1.2 h 2.4 v -1.2 c 0,-0.6 -0.5,-1.2 -1.2,-1.2 z m 0,0 c -0.7,0 -1.2,0.6 -1.2,1.2 v 1.2 h 2.4 v -1.2 c 0,-0.6 -0.5,-1.2 -1.2,-1.2 z m 0,0 c -0.7,0 -1.2,0.6 -1.2,1.2 v 1.2 h 2.4 v -1.2 c 0,-0.6 -0.5,-1.2 -1.2,-1.2 z" id="path30" />';
export const customSvgStartCT = '<path d="m 20.4,2.4 h -5 C 14.7,0.5 12.7,-0.4 10.8,0.3 9.8,0.6 9,1.4 8.6,2.4 h -5 C 2.3,2.4 1.2,3.5 1.2,4.8 v 16.9 c 0,1.3 1.1,2.4 2.4,2.4 h 16.8 c 1.3,0 2.4,-1.1 2.4,-2.4 V 4.8 c 0,-1.4 -1.1,-2.4 -2.4,-2.4 z m -8.4,0 c 0.7,0 1.2,0.6 1.2,1.2 0,0.7 -0.6,1.2 -1.2,1.2 -0.7,0 -1.2,-0.5 -1.2,-1.2 0,-0.7 0.5,-1.2 1.2,-1.2 z m 4.9,16.1 H 7.2 v -4.8 h 1.2 v -1.2 c 0,-2 1.7,-3.6 3.7,-3.5 1.9,0 3.5,1.6 3.5,3.5 v 1.2 h 1.2 v 4.8 z M 20.4,7.4 H 3.6 V 6.3 H 20.4 V 7.4 Z M 12,11.3 c -0.7,0 -1.2,0.6 -1.2,1.2 v 1.2 h 2.4 v -1.2 c 0,-0.6 -0.5,-1.2 -1.2,-1.2 z" id="path28" />';
export const customSvgSystemWidget = '<path d="M 19.4,15.9 C 19,15.7 18.6,15.5 18.2,15.5 v 0 c -0.4,0 -0.8,0.1 -1.2,0.3 -0.4,0.2 -0.8,0.6 -1,1.1 -0.1,0.3 -0.2,0.6 -0.2,1 0,0.1 0,0.2 0,0.2 0,0.4 0.2,0.9 0.5,1.2 0.4,0.5 1,0.9 1.9,0.9 1.3,0 2.4,-1 2.4,-2.4 C 20.5,17 20,16.3 19.4,15.9 Z m -1.3,3.5 c -0.2,0 -0.4,0 -0.6,-0.1 -0.5,-0.2 -0.8,-0.7 -0.9,-1.2 0,-0.1 0,-0.1 0,-0.2 0,-0.8 0.7,-1.5 1.5,-1.6 h 0.1 c 0.5,0 1,0.3 1.2,0.6 0.2,0.3 0.3,0.6 0.3,1 0,0.8 -0.7,1.5 -1.6,1.5 z m 5.5,-0.5 c -0.2,-0.1 -0.4,-0.3 -0.6,-0.4 -0.1,0 -0.1,-0.1 -0.1,-0.2 0,-0.3 0,-0.6 0,-1 0,-0.1 0,-0.1 0.1,-0.1 0.2,-0.1 0.5,-0.3 0.7,-0.4 0.2,-0.1 0.4,-0.4 0.3,-0.7 -0.3,-0.9 -0.7,-1.7 -1.4,-2.4 -0.2,-0.3 -0.5,-0.3 -0.8,-0.1 -0.2,0.1 -0.4,0.2 -0.6,0.4 -0.1,0.1 -0.2,0.1 -0.3,0 -0.3,-0.2 -0.5,-0.3 -0.8,-0.5 -0.1,0 -0.1,-0.1 -0.1,-0.2 0,-0.1 0,-0.3 0,-0.4 v -0.3 c 0,-0.4 -0.2,-0.6 -0.5,-0.7 0,0 -0.1,0 -0.1,0 -0.4,-0.1 -0.8,-0.1 -1.2,-0.1 -0.4,0 -0.8,0 -1.2,0.1 h -0.2 c -0.3,0.1 -0.5,0.3 -0.5,0.6 0,0.2 0,0.5 0,0.7 0,0.1 0,0.2 -0.1,0.2 -0.2,0.1 -0.3,0.1 -0.4,0.2 -0.1,0.1 -0.3,0.2 -0.4,0.3 -0.1,0.1 -0.1,0.1 -0.2,0 -0.2,-0.1 -0.4,-0.2 -0.6,-0.4 -0.3,-0.2 -0.6,-0.1 -0.8,0.1 -0.5,0.6 -0.9,1.2 -1.2,2 0,0.1 -0.1,0.2 -0.1,0.4 -0.1,0.4 0,0.6 0.3,0.8 0,0 0,0 0.1,0 0.2,0.1 0.4,0.2 0.5,0.3 0.1,0 0.1,0.1 0.1,0.2 0,0.2 0,0.5 0,0.7 0,0.1 0,0.1 0,0.2 0,0.1 0,0.1 -0.1,0.2 -0.2,0.1 -0.5,0.3 -0.7,0.4 -0.1,0.1 -0.2,0.2 -0.3,0.4 0,0.1 0,0.2 0,0.3 0.3,0.9 0.7,1.7 1.4,2.4 0.2,0.2 0.5,0.3 0.8,0.1 0.2,-0.1 0.5,-0.3 0.7,-0.4 0.1,-0.1 0.1,-0.1 0.2,0 0.3,0.2 0.5,0.3 0.8,0.5 0.1,0 0.1,0.1 0.1,0.2 0,0.3 0,0.5 0,0.8 0,0.3 0.2,0.5 0.5,0.6 0.9,0.2 1.9,0.2 2.8,0 0.3,-0.1 0.5,-0.3 0.5,-0.6 0,-0.3 0,-0.5 0,-0.7 0,-0.1 0,-0.2 0.1,-0.2 0.3,-0.1 0.6,-0.3 0.8,-0.5 0.1,-0.1 0.1,-0.1 0.2,0 0.2,0.1 0.4,0.2 0.6,0.3 0.4,0.2 0.6,0.2 1,-0.1 0.6,-0.7 1,-1.4 1.3,-2.3 -0.1,-0.2 -0.3,-0.5 -0.6,-0.7 z m -0.5,0.8 c -0.2,0.6 -0.5,1.1 -0.9,1.6 -0.1,0.1 -0.1,0.1 -0.2,0.1 -0.3,-0.2 -0.6,-0.3 -0.9,-0.5 -0.1,-0.1 -0.1,-0.1 -0.2,0 -0.4,0.4 -1,0.7 -1.5,0.9 -0.1,0 -0.1,0.1 -0.1,0.2 0,0.4 0,0.7 0,1 0,0.1 0,0.2 -0.2,0.2 -0.6,0.1 -1.2,0.1 -1.8,0 -0.1,0 -0.2,-0.1 -0.2,-0.2 0,-0.3 0,-0.6 0,-1 0,-0.1 0,-0.2 -0.2,-0.2 -0.5,-0.2 -1,-0.5 -1.5,-0.9 -0.1,-0.1 -0.2,-0.1 -0.3,0 -0.3,0.2 -0.6,0.3 -0.9,0.5 -0.1,0 -0.1,0 -0.2,0 -0.4,-0.5 -0.7,-1 -0.9,-1.6 0,-0.1 0,-0.2 0.1,-0.2 0.1,0 0.2,-0.1 0.3,-0.1 0.2,-0.1 0.5,-0.2 0.7,-0.4 0.1,0 0.1,-0.1 0.1,-0.2 0,-0.2 -0.1,-0.4 -0.1,-0.7 0,-0.1 0,-0.1 0,-0.2 0,-0.3 0,-0.6 0.1,-0.9 0,0 0,-0.1 0,-0.1 0,0 -0.1,-0.1 -0.1,-0.1 -0.3,-0.2 -0.6,-0.3 -0.9,-0.5 -0.1,0 -0.1,-0.1 -0.1,-0.2 0.1,-0.1 0.1,-0.3 0.2,-0.4 0.2,-0.4 0.5,-0.8 0.8,-1.2 0.1,-0.1 0.1,-0.1 0.2,0 0.3,0.2 0.6,0.3 0.9,0.5 0.1,0.1 0.2,0.1 0.3,0 0.1,-0.1 0.2,-0.2 0.3,-0.2 0.4,-0.3 0.8,-0.5 1.2,-0.6 0,0 0,0 0,0 0.1,0 0.1,-0.1 0.1,-0.2 v -1 c 0,-0.1 0,-0.2 0.1,-0.2 0.3,-0.1 0.6,-0.1 0.9,-0.1 0.3,0 0.6,0 0.9,0.1 0.1,0 0.1,0.1 0.1,0.2 v 1 c 0,0.1 0,0.2 0.2,0.3 v 0 c 0.5,0.2 1,0.4 1.4,0.8 0.1,0.1 0.2,0.1 0.4,0 0.3,-0.2 0.5,-0.3 0.8,-0.5 0.1,-0.1 0.2,0 0.2,0.1 0.4,0.5 0.7,1 0.9,1.6 0,0.1 0,0.1 -0.1,0.2 -0.3,0.2 -0.6,0.3 -0.9,0.5 C 22,16.9 22,16.9 22,17 c 0.1,0.6 0.1,1.2 0,1.7 0,0.1 0,0.2 0.1,0.2 0.3,0.2 0.6,0.4 0.9,0.5 0.1,0.1 0.1,0.2 0.1,0.3 z M 16.6,9.6 c -2.2,0 -4.4,0 -6.6,0 -0.3,0 -0.3,0 -0.3,-0.3 0,-2.2 0,-4.4 0,-6.6 0,-0.3 0,-0.3 -0.3,-0.3 H 2.7 c -0.3,0 -0.3,0 -0.3,0.3 v 6.7 c 0,0.3 0,0.3 0.3,0.3 h 6.6 c 0.3,0 0.3,0 0.3,0.3 v 6.6 c 0,0.3 0,0.3 0.3,0.3 0.1,-1.1 0.5,-2.1 1,-3 v -0.7 c 0,-0.7 0,-1.4 0,-2.1 0,-0.2 0.1,-0.3 0.3,-0.3 0.9,0 1.8,0 2.6,0 0.9,-0.6 2,-1 3.1,-1.1 0,-0.1 -0.1,-0.1 -0.3,-0.1 z M 8.4,8.2 C 8.4,8.4 8.3,8.5 8.1,8.5 H 3.9 C 3.7,8.5 3.6,8.4 3.6,8.2 c 0,-0.7 0,-1.4 0,-2.1 V 3.9 C 3.6,3.7 3.7,3.6 3.9,3.6 h 4.2 c 0.2,0 0.3,0.1 0.3,0.3 0,1.4 0,2.9 0,4.3 z M 18.2,0 C 18,0 17.8,0 17.7,0 H 1.4 C 1.2,0 0.9,0 0.7,0.1 0.2,0.4 0,0.8 0,1.4 0,6.9 0,12.5 0,18 c 0,0.6 0.5,1.4 1.4,1.3 2.8,0 5.5,0 8.3,0 H 10 C 9.9,18.9 9.9,18.5 9.9,18.1 H 1.6 c -0.3,0 -0.3,0 -0.3,-0.3 V 1.6 c 0,-0.3 0,-0.3 0.3,-0.3 h 16.2 c 0.3,0 0.3,0 0.3,0.3 v 8.1 c 0.4,0 0.8,0 1.2,0.1 V 1.2 C 19.4,0.6 18.9,0.1 18.2,0 Z" id="path181" />';
export const customSvgThirdPartyWidget = '<path d="m 17.4,11.7 c 1.5,0 3,1.2 3.1,3 0.1,1.7 -1.2,3 -2.8,3.2 -1.9,0.2 -3.2,-1.2 -3.4,-2.8 -0.2,-1.9 1.3,-3.5 3.1,-3.4 z m 0,0.7 c -1.3,0 -2.3,1 -2.3,2.3 0,1.3 1,2.3 2.3,2.3 1.3,0 2.3,-1 2.3,-2.3 0,-1.2 -1.1,-2.3 -2.3,-2.3 z m 0,11.6 c -1.4,0 -2.8,0 -4.2,0 -0.6,0 -1.2,-0.5 -1.2,-1.1 0,-0.5 0,-1 0,-1.5 0.1,-1 0.6,-1.7 1.4,-2.2 0.7,-0.4 1.4,-0.6 2.2,-0.5 0.3,0 0.5,0.1 0.8,0.2 0.7,0.2 1.5,0.2 2.2,-0.1 0.3,-0.1 0.5,-0.2 0.8,-0.2 0.5,0 0.9,0.1 1.4,0.2 1,0.5 1.7,1.2 1.9,2.3 0.1,0.3 0.1,0.5 0.1,0.8 0,0.4 0,0.7 0,1.1 -0.1,0.5 -0.6,1 -1.1,1 -1.5,0 -2.9,0 -4.3,0 z m 0,-0.8 c 0,0 0,0 0,0 1.4,0 2.7,0 4.1,0 0.1,0 0.1,0 0.2,0 0.2,0 0.3,-0.2 0.3,-0.4 0,-0.4 0,-0.9 0,-1.3 -0.1,-0.9 -0.9,-1.8 -1.7,-2 -0.5,-0.1 -1,-0.1 -1.5,0.1 -0.9,0.3 -1.8,0.3 -2.7,0 -0.3,-0.1 -0.6,-0.2 -1,-0.2 -1.1,0.1 -2,0.9 -2.2,2 -0.1,0.5 0,1 0,1.5 0,0.1 0,0.2 0.1,0.2 0.1,0.1 0.3,0.1 0.4,0.1 1.2,0 2.6,0 4,0 z M 16.6,9.6 c -2.2,0 -4.4,0 -6.6,0 -0.3,0 -0.3,0 -0.3,-0.3 0,-2.2 0,-4.4 0,-6.6 0,-0.3 0,-0.3 -0.3,-0.3 H 2.7 c -0.3,0 -0.3,0 -0.3,0.3 v 6.7 c 0,0.3 0,0.3 0.3,0.3 h 6.6 c 0.3,0 0.3,0 0.3,0.3 v 6.6 c 0,0.3 0,0.3 0.3,0.3 0.1,-1.1 0.5,-2.1 1,-3 v -0.7 c 0,-0.7 0,-1.4 0,-2.1 0,-0.2 0.1,-0.3 0.3,-0.3 0.9,0 1.7,0 2.6,0 0.9,-0.6 2,-1 3.1,-1.1 0,-0.1 -0.1,-0.1 -0.3,-0.1 z M 8.4,8.2 C 8.4,8.4 8.3,8.5 8.1,8.5 H 3.9 C 3.7,8.5 3.6,8.4 3.6,8.2 c 0,-0.7 0,-1.4 0,-2.1 V 3.9 C 3.6,3.7 3.7,3.6 3.9,3.6 h 4.2 c 0.2,0 0.3,0.1 0.3,0.3 0,1.4 0,2.9 0,4.3 z M 18.2,0 C 18,0 17.8,0 17.7,0 H 1.4 C 1.2,0 0.9,0 0.7,0.1 0.2,0.4 0,0.8 0,1.4 c 0,5.5 0,11 0,16.6 0,0.7 0.5,1.3 1.3,1.3 2.8,0 5.5,0 8.3,0 H 10 C 9.9,18.9 9.9,18.5 9.9,18.1 H 1.6 c -0.3,0 -0.3,0 -0.3,-0.3 V 1.6 c 0,-0.3 0,-0.3 0.3,-0.3 h 16.2 c 0.3,0 0.3,0 0.3,0.3 v 8.1 c 0.4,0 0.8,0 1.2,0.1 V 1.2 C 19.3,0.6 18.9,0.1 18.2,0 Z" id="path477" />';
export const customSvgImageUrl = '<path d="m 24,11.3 c 0,0.7 -0.3,1.3 -0.8,1.8 l -0.6,0.6 c -0.2,0.2 -0.5,0 -0.5,-0.2 0,-0.3 -0.1,-0.6 -0.2,-0.9 0,-0.1 0,-0.2 0.1,-0.3 l 0.2,-0.2 c 0.5,-0.5 0.5,-1.3 0,-1.8 C 21.8,10 21.3,9.9 20.9,10 c -0.2,0 -0.3,0.1 -0.5,0.3 l -1.1,1.2 c -0.5,0.5 -0.5,1.3 0,1.7 0.1,0.1 0.1,0.1 0.2,0.1 0.1,0.1 0.1,0.1 0.1,0.2 0,0.2 -0.1,0.4 -0.2,0.5 L 19,14.4 c -0.1,0.1 -0.2,0.1 -0.3,0 -0.1,-0.1 -0.2,-0.2 -0.4,-0.3 -1,-1 -1,-2.6 0,-3.7 0,0 0,0 0,0 l 1.1,-1.1 c 0.4,0 0.6,-0.2 0.8,-0.3 1,-0.5 2.2,-0.4 3,0.5 0.5,0.4 0.8,1.1 0.8,1.8 z m -3.2,4.2 c 0,0 0,0 0,0 l -1.2,1.2 c -1,1 -2.7,1 -3.7,0 -0.5,-0.5 -0.7,-1 -0.7,-1.6 -0.1,-0.7 0.2,-1.5 0.7,-2 l 0.6,-0.6 c 0.2,-0.2 0.5,-0.1 0.5,0.2 0,0.3 0.1,0.6 0.2,0.9 0,0.1 0,0.2 -0.1,0.3 H 17 c -0.3,0.3 -0.4,0.7 -0.4,1.1 0,0.2 0.1,0.5 0.3,0.7 0.5,0.5 1.3,0.5 1.8,0 l 1.1,-1.1 c 0.5,-0.5 0.5,-1.3 0,-1.8 -0.1,-0.1 -0.1,-0.1 -0.2,-0.1 -0.1,-0.1 -0.1,-0.1 -0.1,-0.2 0,-0.2 0,-0.4 0.2,-0.5 l 0.4,-0.4 c 0.1,-0.1 0.2,-0.1 0.3,0 0.1,0.1 0.3,0.2 0.4,0.3 0.1,0.1 0.1,0.1 0.2,0.2 0.8,1 0.8,2.5 -0.2,3.4 z M 21.7,0 H 2.2 C 1,0 -0.1,1 -0.1,2.3 v 13.5 c 0,1.3 1,2.3 2.3,2.3 h 12.6 c -0.7,-0.9 -1.2,-1.9 -1.4,-3 H 2.9 V 12.8 L 6.3,9.5 C 6.5,9.3 6.9,9.3 7.1,9.5 L 9.7,12 16.1,5.6 c 0.2,-0.2 0.6,-0.2 0.8,0 L 18.3,7 c 0.6,-0.2 1.2,-0.3 1.9,-0.3 1.4,0 2.7,0.4 3.8,1.1 V 2.3 C 24,1 23,0 21.7,0 Z M 5.2,7.9 C 3.8,7.9 2.6,6.7 2.6,5.3 2.6,3.8 3.8,2.7 5.2,2.7 c 1.5,0 2.6,1.2 2.6,2.6 0,1.4 -1.1,2.6 -2.6,2.6 z" id="path123" />';
export const customSvgJWPlayer = '<path d="M35.84,.12c-.65-.3-1.41-.02-1.71,.63-.31,.66-8.25,19.83-8.25,19.83-.26,.6-.43,.54-.43-.09,0,0,.03-6.68,.06-12.18,.03-3-1.46-4.68-3.54-5.02-.96-.14-1.93,.08-2.74,.6-.84,.59-1.51,1.38-1.94,2.31-.63,1.23-4.51,12.53-4.51,12.53-.2,.6-.4,.57-.4-.06,0,0-.11-4.88-.23-6.02-.17-1.77-.57-4.65-2.85-4.79-2.14-.14-3.11,2.51-3.65,4.14-.37,1.08-2.14,6.93-2.14,6.93l-.26,.6h0c-.09,.31-.23,.31-.31,0l-.14-.54c-.15-.58-.33-1.15-.54-1.71-.08-.31-.23-.6-.43-.86-.29-.31-.74-.43-1.14-.29C.31,16.26,.04,16.61,0,17.01c0,.34,.03,.69,.09,1.03,.15,1.03,.89,5.08,1.34,5.96,.45,.88,1.43,1.34,2.34,.86,.86-.46,1.26-1.51,1.6-2.34,.43-1.06,2.63-7.11,2.63-7.11,.23-.6,.4-.57,.37,.06,0,0-.11,5.94-.11,8.62,0,1,.09,2.82,.37,3.8,.16,.65,.53,1.23,1.06,1.66,.52,.39,1.17,.57,1.83,.51,.32-.04,.63-.15,.91-.31,.39-.24,.74-.55,1.03-.91,.63-.86,1.17-1.78,1.63-2.74,1.06-2.08,3.8-8.53,3.8-8.53,.26-.6,.43-.54,.43,.09,0,0-.34,10.84-.34,14.98,0,1.03,.2,2.06,.57,3.02,.33,.92,1,1.67,1.88,2.08,.96,.42,2.06,.35,2.97-.17,.69-.42,1.26-1.01,1.66-1.71,.55-.96,1.02-1.96,1.4-3,.83-2.14,1.51-4.31,2.2-6.51,.68-2.2,6.48-22.88,6.85-24.65,.05-.2,.07-.4,.06-.6-.06-.42-.31-.78-.68-.97Z"/>';
export const customSvgXTwitter = '<path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="currentColor" />';

export function addNotesMode() {
  $.FroalaEditor.DefineIcon('notes', { NAME: 'sticky-note' });
  $.FroalaEditor.RegisterCommand('notes', {
    title: 'Mark as notes (CTRL+E)',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () {
      this.format.toggle('gd-editor-note', {
        class: 'gd-froala-editor__notes',
        'data-type': EmbeddedType.Note,
        'data-author-username': this.opts.userData.username,
        contenteditable: 'true'
      });
    }
  });
}

export function addEmbedFacebookPost(contextComponent) {
  $.FroalaEditor.DefineIconTemplate('fab', '<mat-icon class="mat-icon froala fab fa-[NAME]"></mat-icon>');

  // Define Icon
  $.FroalaEditor.DefineIcon('facebook', { NAME: 'facebook-f', template: 'fab' });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('facebook', {
    title: 'Embed Facebook Post',
    icon: 'facebook',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { insertFacebookPostPlaceholder(this); }
  });

  // Define command to be executed via hotkey
  $.FroalaEditor.RegisterCommand('facebookPostInsertViaHotkey', {
    undo: true,
    callback: function () { insertFacebookPostPlaceholder(this, true); }
  });

  // Define quick insert command for facebook posts
  $.FroalaEditor.RegisterQuickInsertButton('quickInsertFacebookPost', {
    title: 'Embed Facebook Post',
    undo: true,
    icon: 'facebook',
    callback: function () { insertFacebookPostPlaceholder(this, true); }
  });

  function insertFacebookPostPlaceholder(editor, quick = false) {
    const elId = generateShortId();
    editor.image.insert('./assets/img/facebook-logo-grey.png', true, {
      'quick': quick,
      'block-id': elId,
      'embed-type': EmbeddedType.FacebookPost,
    });
  }
}
export function addEmbedTwitterPost(contextComponent) {

  $.FroalaEditor.DefineIconTemplate('customSvg2', '<svg height="14px" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">[PATH]</svg>');
  // Define Icon
  $.FroalaEditor.DefineIcon('twitter', { PATH: customSvgXTwitter, ALT: 'Twitter / X button', template: 'customSvg2' });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('twitter', {
    title: 'Embed Twitter / X Post',
    icon: 'twitter',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { insertTwitterPostPlaceholder(this); }
  });

  // Define command to be executed via hotkey
  $.FroalaEditor.RegisterCommand('twitterPostInsertViaHotkey', {
    undo: true,
    callback: function () { insertTwitterPostPlaceholder(this, true); }
  });

  // Define quick insert command for twitter posts
  $.FroalaEditor.RegisterQuickInsertButton('quickInsertTwitterPost', {
    title: 'Embed Twitter / X Post',
    undo: true,
    icon: 'twitter',
    callback: function () { insertTwitterPostPlaceholder(this, true); }
  });

  function insertTwitterPostPlaceholder(editor, quick = false) {
    const elId = generateShortId();
    editor.image.insert('./assets/img/x-twitter-logo-white.png', true, {
      'quick': quick,
      'block-id': elId,
      'embed-type': EmbeddedType.TwitterPost,
    });
  }
}

export function addEmbedVimeoVideo(contextComponent) {
  // Define Icon
  $.FroalaEditor.DefineIcon('vimeo', { NAME: 'vimeo-v', template: 'fab' });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('vimeo', {
    title: 'Embed Vimeo Video',
    icon: 'vimeo',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { insertVimeoVideoPlaceholder(this); }
  });

  // Define command to be executed via hotkey
  $.FroalaEditor.RegisterCommand('vimeoVideoInsertViaHotkey', {
    undo: true,
    callback: function () { insertVimeoVideoPlaceholder(this, true); }
  });

  // Define quick insert command for twitter posts
  $.FroalaEditor.RegisterQuickInsertButton('quickInsertVimeo', {
    title: 'Embed Vimeo Video',
    undo: true,
    icon: 'vimeo',
    callback: function () { insertVimeoVideoPlaceholder(this, true); }
  });

  function insertVimeoVideoPlaceholder(editor, quick = false) {
    const elId = generateShortId();
    editor.image.insert('./assets/img/vimeo-logo-grey.png', true, {
      'quick': quick,
      'block-id': elId,
      'embed-type': EmbeddedType.Vimeo,
    });
  }
}

export function addEmbedBrightcoveVideo(contextComponent) {
  $.FroalaEditor.DefineIconTemplate('customSvg', '<svg viewBox="0 0 24 24" style="fill: currentColor; height: 14px;" xmlns="http://www.w3.org/2000/svg">[PATH]</svg>')
  // Define Icon
  $.FroalaEditor.DefineIcon('brightcove', { NAME: 'glideCustomIcon_brightcove', PATH: customSvgBrightcove , ALT: 'Brightcove button', template: 'customSvg' });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('brightcove', {
    title: 'Embed Brightcove Video',
    icon: 'brightcove',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { insertBrightcoveVideoPlaceholder(this); }
  });

  // Define command to be executed via hotkey
  $.FroalaEditor.RegisterCommand('brightcoveVideoInsertViaHotkey', {
    undo: true,
    callback: function () { insertBrightcoveVideoPlaceholder(this, true); }
  });

  // Define quick insert command for brightcove posts
  $.FroalaEditor.RegisterQuickInsertButton('quickInsertBrightcove', {
    title: 'Embed Brightcove Video',
    undo: true,
    icon: 'brightcove',
    callback: function () { insertBrightcoveVideoPlaceholder(this, true); }
  });

  function insertBrightcoveVideoPlaceholder(editor, quick = false) {
    const elId = generateShortId();
    editor.image.insert('./assets/img/brightcove-logo-grey.png', true, {
      'quick': quick,
      'block-id': elId,
      'embed-type': EmbeddedType.Brightcove,
    });
  }
}

export function addEmbedBrightcovePlaylist(contextComponent) {
  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('brightcovePlaylist', {
    title: 'Embed Brightcove Playlist',
    icon: 'brightcove',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { insertBrightcovePlaylistPlaceholder(this); }
  });

  // Define command to be executed via hotkey
  $.FroalaEditor.RegisterCommand('brightcovePlaylistInsertViaHotkey', {
    undo: true,
    callback: function () { insertBrightcovePlaylistPlaceholder(this, true); }
  });

  // Define quick insert command for brightcove posts
  $.FroalaEditor.RegisterQuickInsertButton('quickInsertBrightcovePlaylist', {
    title: 'Embed Brightcove Playlist',
    undo: true,
    icon: 'brightcove',
    callback: function () { insertBrightcovePlaylistPlaceholder(this, true); }
  });

  function insertBrightcovePlaylistPlaceholder(editor, quick = false) {
    const elId = generateShortId();
    editor.image.insert('./assets/img/brightcove-logo-grey.png', true, {
      'quick': quick,
      'block-id': elId,
      'embed-type': EmbeddedType.BrightcovePlaylist,
    });
  }
}

export function addEmbedYouTubeVideo(contextComponent) {
  // Define Icon
  $.FroalaEditor.DefineIcon('youtube', { NAME: 'youtube', template: 'fab' });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('youtube', {
    title: 'Embed YouTube Video (CTRL+Y)',
    icon: 'youtube',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { insertYouTubePlaceholder(this); }
  });

  // Define command to be executed via hotkey
  $.FroalaEditor.RegisterCommand('youtubeInsertViaHotkey', {
    undo: true,
    callback: function () { insertYouTubePlaceholder(this, true); }
  });

  // Define quick insert command for youTube videos
  $.FroalaEditor.RegisterQuickInsertButton('quickInsertYouTube', {
    title: 'Embed YouTube Video',
    undo: true,
    icon: 'youtube',
    callback: function () { insertYouTubePlaceholder(this, true); }
  });

  function insertYouTubePlaceholder(editor, quick = false) {
    const elId = generateShortId();
    editor.image.insert('./assets/img/youtube-logo-grey.png', true, {
      'quick': quick,
      'block-id': elId,
      'embed-type': EmbeddedType.YouTube,
    });
  }
}

export function addEmbedImage(contextComponent) {
  // Define command to be executed from the toolbar
  $.FroalaEditor.DefineIconTemplate('fal', '<mat-icon class="mat-icon froala fal fa-[NAME]"></mat-icon>');
  $.FroalaEditor.DefineIcon('image', { NAME: 'image', template: 'far' });
  $.FroalaEditor.RegisterCommand('insertImage', {
    title: 'Embed Image',
    icon: 'image',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { contextComponent.embedContent({ embedType: EmbeddedType.Image }) }
  });

  // Define quick insert command for images
  $.FroalaEditor.RegisterQuickInsertButton('quickInsertImage', {
    title: 'Embed Image',
    undo: true,
    icon: 'image',
    callback: function () { contextComponent.embedContent({ embedType: EmbeddedType.Image }) }
  });
}

function insertImageFromGM(editor, imgData) {
  const elId = generateShortId();
  editor.image.insert(imgData.preview, true, {
    'block-id': elId,
    'embed-type': EmbeddedType.Image,
    'id': imgData.id,
  });
}

export function addEmbedGallery(contextComponent) {
  const placeholderImg = './assets/img/gallery-placeholder-grey.svg';
  // Define Icon
  $.FroalaEditor.DefineIcon('insertGallery', { NAME: 'images', ALT: 'Gallery button', template: 'far' });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('insertGallery', {
    title: 'Embed Gallery',
    icon: 'insertGallery',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { insertGalleryPlaceholder(this); }
  });

  // Define quick insert command for gallery
  $.FroalaEditor.RegisterQuickInsertButton('quickInsertGallery', {
    title: 'Embed Gallery',
    undo: true,
    icon: 'insertGallery',
    callback: function () { insertGalleryPlaceholder(this, true); }
  });

  function insertGalleryPlaceholder(editor, quick = false) {
    const elId = generateShortId();
    editor.image.insert(placeholderImg, true, {
      'quick': quick,
      'block-id': elId,
      'embed-type': EmbeddedType.Gallery,
    });
  }
}

export function addEmbedFile(contextComponent) {
  const placeholderImg = theme === 'default' ? 'assets/img/files/default.svg' : 'assets/img/files/dark/default.svg';
  // Define command to be executed from the toolbar
  $.FroalaEditor.DefineIcon('insertFile', { NAME: 'file' , ALT: 'File button', template: 'far' });
  $.FroalaEditor.RegisterCommand('insertFile', {
    title: 'Embed File',
    icon: 'insertFile',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { contextComponent.embedContent({ embedType: EmbeddedType.File }) }
  });

  // Define quick insert command for images
  $.FroalaEditor.RegisterQuickInsertButton('quickInsertFile', {
    title: 'Embed File',
    undo: true,
    icon: 'insertFile',
    callback: function () { contextComponent.embedContent({ embedType: EmbeddedType.File }) }
  });

  function insertFilePlaceholder(editor, quick = false) {
    const elId = generateShortId();
    editor.image.insert(placeholderImg, true, {
      'quick': quick,
      'block-id': elId,
      'embed-type': EmbeddedType.File,
    });
  }
}


export function addEmbedInstagramPost(contextComponent) {
  // Define Icon
  $.FroalaEditor.DefineIcon('instagram', { NAME: 'instagram', template: 'fab' });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('instagram', {
    title: 'Embed Instagram Post',
    icon: 'instagram',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { insertInstagramPostPlaceholder(this); }
  });

  // Define quick insert command for Instagram posts
  $.FroalaEditor.RegisterQuickInsertButton('quickInsertInstagramPost', {
    title: 'Embed Instagram Post',
    undo: true,
    icon: 'instagram',
    callback: function () { insertInstagramPostPlaceholder(this, true); }
  });

  function insertInstagramPostPlaceholder(editor, quick = false) {
    const elId = generateShortId();
    editor.image.insert('./assets/img/instagram-logo-grey.svg', true, {
      'quick': quick,
      'block-id': elId,
      'embed-type': EmbeddedType.InstagramPost,
    });
  }
}

export function addEmbedSystemWidget(contextComponent) {
  // Define Icon
  $.FroalaEditor.DefineIcon('systemWidget', { PATH: customSvgSystemWidget, ALT: 'System Widget', template: 'customSvg' });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('systemWidget', {
    title: 'Embed System Widget',
    icon: 'systemWidget',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { contextComponent.embedContent({ embedType: EmbeddedType.SystemWidget }); }
  });
}

export function addEmbedThirdPartyWidget(contextComponent) {
  // Define Icon
  $.FroalaEditor.DefineIcon('thirdPartyWidget', { PATH: customSvgThirdPartyWidget, ALT: 'Third Party Widget', template: 'customSvg' });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('thirdPartyWidget', {
    title: 'Embed Third Party Widget',
    icon: 'thirdPartyWidget',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { contextComponent.embedContent({ embedType: EmbeddedType.ThirdPartyWidget }); }
  });
}

/**
 * This adds the direction change buttons so that individual calculations
 *
 *
 * @param contextComponent the editor parent component
 */
export function addRTLButtons(contextComponent) {
  var changeDirection = function (dir, align) {
    // Wrap block tags.
    this.selection.save();
    this.html.wrap(true, true, true, true);
    this.selection.restore();

    // Get blocks.
    var elements = this.selection.blocks();

    // Save selection to restore it later.
    this.selection.save();

    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];
      if (element != this.$el.get(0)) {
        $(element)
          .css('direction', dir)
          .css('text-align', align)
          .removeClass('fr-temp-div');
      }
    }

    // Unwrap temp divs.
    this.html.unwrap();

    // Restore selection.
    this.selection.restore();
  }

  $.FroalaEditor.DefineIcon('rightToLeft', {NAME: 'long-arrow-left'});
  $.FroalaEditor.RegisterCommand('rightToLeft', {
    title: 'RTL',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () {
      changeDirection.apply(this, ['rtl', 'right']);
    }
  })

  $.FroalaEditor.DefineIcon('leftToRight', {NAME: 'long-arrow-right'});
  $.FroalaEditor.RegisterCommand('leftToRight', {
    title: 'LTR',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () {
      changeDirection.apply(this, ['ltr', 'left']);
    }
  })
}

export function translateFroalaCommands() {
  const locale = getLocaleCode();
  if(!$.FroalaEditor.LANGUAGE[locale]) {
    return;
  }

  const froalaCoreTranslations = $.FroalaEditor.LANGUAGE[locale].translation;
  $.FroalaEditor.LANGUAGE[locale].translation = {...froalaCoreTranslations, ...customCommandsTranslations };
}

export function addEmbedContentTag(contextComponent) {
  // Define Icon
  $.FroalaEditor.DefineIcon('insertContentTag', { PATH: customSvgStartCT, ALT: 'Content Tag', template: 'customSvg' });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('insertContentTag', {
    title: 'Insert Content Tag',
    icon: 'insertContentTag',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () {
      contextComponent.embedContent({ embedType: EmbeddedType.ContentTag });
    }
  });
}

// this allows for changing regular table cells into header cells
export function addTableHeaderCell(contextComponent) {
  $.FroalaEditor.DefineIcon('tableHeaderCell', { NAME: 'th' });
  $.FroalaEditor.RegisterCommand('tableHeaderCell', {
    title: 'Cell Header',
    focus: false,
    undo: true,
    toggle: true,
    refreshAfterCallback: false,
    callback: function tableHeaderCellCallback() {
      const blocks = this.selection.blocks();
      const table = $(blocks[0]).parents('table');
      const selectedCells = table.find('.fr-selected-cell');
      const affectedRows = selectedCells.parent();

      const allSelectedHeaders = selectedCells.toArray().every(c => c.tagName === 'TH');
      const convertToTag = allSelectedHeaders ? 'TD' : 'TH';

      // selected cells will be turned from TD to TH and TH to TD
      // if not all cells are TH, they will first be converted to TH and on next action to TD
      selectedCells.toArray()
        .filter(el => el.tagName !== convertToTag)
        .forEach(el => {
          if (!el.id) {
            el.id = generateShortId();
          }
          const el2 = document.createElement(convertToTag);
          duplicateChildNodes(el.id, el2);
          el2.setAttribute('id', el.getAttribute('id'));
          el2.id = el.id;
          el2.setAttribute('style', el.getAttribute('style'));
          el2.setAttribute('class', el.getAttribute('class'));
          // TODO perhaps copy data attributes as well
          el.replaceWith(el2);
        });

      // if all cells in the row are headers, add the filler TD cell
      // to prevent Froala from messing with the
      if (convertToTag === 'TH') {
        affectedRows.toArray().forEach(row => {
          const allChildrenAreHeaders = $(row)
            .children()
            .toArray()
            .every(cell => cell.tagName === 'TH');
          if (allChildrenAreHeaders) {
            $(row).append(`<td id="${generateShortId()}" style="display: none;" class="gd-temp-node"></td>`);
          }
        });
      }
    },
    // highlight the button if all selected cells are table header cells or TH cells
    refresh: function tableHeaderCellRefresh($btn) {
      const blocks = this.selection.blocks();
      const selectedCells = $(blocks[0]).parents('table').find('.fr-selected-cell');
      const allSelectedHeaders = selectedCells.toArray().every(c => c.tagName === 'TH');
      if (allSelectedHeaders) {
        $btn.addClass('fr-active');
      } else {
        $btn.removeClass('fr-active');
      }
    }
  });

  function duplicateChildNodes (oldParentId, newParent){
    const parent = document.getElementById(oldParentId);
    const children = parent.childNodes;
    children.forEach((item) => newParent.appendChild(item.cloneNode(true)));
  }
}

export function closeContentTag(contextComponent) {
  // Define Icon
  $.FroalaEditor.DefineIcon('closeContentTag', { PATH: customSvgCloseCT, ALT: 'Content Tag', template: 'customSvg' });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('closeContentTag', {
    title: 'Close Content Tag',
    'icon': 'closeContentTag',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { contextComponent.insertClosingTagMarker(this); }
  });
}

export function embedArticleLink(contextComponent) {
  // Define Icon
  $.FroalaEditor.DefineIcon('article-link', { NAME: 'quote-right', template: 'far' });

  // Define quick insert command for article links
  $.FroalaEditor.RegisterQuickInsertButton('quickInsertArticleLink', {
    title: 'Embed Article Link',
    undo: true,
    icon: 'article-link',
    callback: function () { insertArticleMentionTriggerKey(this, contextComponent); }
  });

  function insertArticleMentionTriggerKey(editor, component) {
    const element = editor.selection.get() && editor.selection.get().anchorNode;
    if (element) {
      element.removeChild(element.childNodes[0]);
      component.showInternalLinksDropdown(element, MentionKeys.Article);
    }
  }
}

export function embedTaxonomyLink(contextComponent) {
  // Define Icon
  $.FroalaEditor.DefineIconTemplate('tax-icon-template', '<img src=[SRC] style="width: 16px" />');
  $.FroalaEditor.DefineIcon('tax-icon', { SRC: './assets/img/custom-icons/glideCustomIcon_taxonomies.svg', template: 'tax-icon-template' });
  // Define quick insert command for article links
  $.FroalaEditor.RegisterQuickInsertButton('quickInsertTaxonomyLink', {
    title: 'Embed Taxonomy Link',
    undo: true,
    icon: 'tax-icon',
    callback: function () { insertTaxonomyMentionTriggerKey(this, contextComponent); }
  });

  function insertTaxonomyMentionTriggerKey(editor, component) {
    const element = editor.selection.get() && editor.selection.get().anchorNode;
    if (element) {
      element.removeChild(element.childNodes[0]);
      component.showInternalLinksDropdown(element, MentionKeys.Taxonomy);
    }
  }
}

export function addEmbedImageViaURL(contextComponent) {
  $.FroalaEditor.DefineIconTemplate('customSvg', '<svg viewBox="0 0 24 24" style="fill: currentColor; height: 14px; margin: 12px" xmlns="http://www.w3.org/2000/svg">[PATH]</svg>')
  // Define Icon
  $.FroalaEditor.DefineIcon('imageUrl', { PATH: customSvgImageUrl, ALT: 'Image button', template: 'customSvg', NAME: 'Image via URL' });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('imageUrl', {
    title: 'Embed Image Via URL',
    icon: 'imageUrl',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { insertImageViaURLPlaceholder(this); }
  });

  function insertImageViaURLPlaceholder(editor, quick = false) {
    const elId = generateShortId();
    editor.image.insert('./assets/img/embed-image-url-gray.svg', true, {
      'quick': quick,
      'block-id': elId,
      'embed-type': EmbeddedType.ImageURL,
    });
  }
}

export function stripTags(contextComponent) {
  $.FroalaEditor.DefineIconTemplate('fas', '<mat-icon class="mat-icon froala fas fa-[NAME]"></mat-icon>');
  // Define Icon
  $.FroalaEditor.DefineIcon('stripTags', { NAME: 'remove-format', ALT: 'Strip tags button', template: 'fas' });


  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('stripTags', {
    title: 'Strip Tags',
    icon: 'stripTags',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { contextComponent.stripTags(this); }
  });
}

export function addEditEmbeddable(contextComponent, froalaComponent) {
  $.FroalaEditor.DefineIcon('editEmbed', { NAME: 'cog' });
  $.FroalaEditor.RegisterCommand('editEmbed', {
    title: 'Edit embed',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () {
      if (!this.image.get()) { return; }
      this.events.enableBlur();
      const img = this.image.get()[0];
      const nodeData = froalaComponent.getContentNode(img.id);
      const data = {
        ...nodeData,
        embedType: nodeData.type,
        id: nodeData.dataId,
        blockId: nodeData.id,
        url: nodeData.dataUrl,
        editingMode: true
      };
      const editor = this;
      // some resources have been switched to a new processing functionality
      if ([
          EmbeddedType.Image,
          EmbeddedType.File,
          EmbeddedType.JWPlayerVideo,
          EmbeddedType.JWPlayerPlaylist,
          EmbeddedType.DailymotionVideo,
          EmbeddedType.DailymotionPlaylist,
          EmbeddedType.TwitchVideo,
          EmbeddedType.TwitchStream,
          EmbeddedType.ContentPanel,
          EmbeddedType.AnchorLink,
        ].includes(data.embedType)
      ) {
        contextComponent.embedContent(data);
      } else {
        contextComponent.invokeEmbedDialog(data, img.id, editor);
      }
    }
  });
}

export function bindCustomEditorShortcuts(editor) {
  const editorBody = editor.$el[0];
  Mousetrap(editorBody)
    .bind('ctrl+y', function (e) {
      editor.commands.exec('youtubeInsertViaHotkey');
      return false;
    })
    .bind('ctrl+e', function (e) {
      editor.commands.exec('notes');
      return false;
    });
}

export function unbindCustomEditorShortcuts() {
  Mousetrap.unbind(['ctrl+y', 'ctrl+e']);
}

export async function handleDropEvents(dropEvent, editor, service, contextComponent) {
  dropEvent.preventDefault();
  dropEvent.stopPropagation();

  // Handle case when images are dragged and dropped from FS
  if (!dropEvent.originalEvent.dataTransfer.getData('text/plain') && dropEvent.type === 'drop') {

    // Focus at the current position.
    editor.markers.insertAtPoint(dropEvent.originalEvent);
    const $marker = editor.$el.find('.fr-marker');
    $marker.replaceWith($.FroalaEditor.MARKERS);
    editor.selection.restore();
    // Save into undo stack the current position.
    if (!editor.undo.canDo()) {
      editor.undo.saveStep();
    }

    contextComponent.embedContent({ embedType: EmbeddedType.Image, dropEvent: true });
    const droppedFiles = Array.from(dropEvent.originalEvent.dataTransfer.files);
    droppedFiles.forEach((file: any) => {
      const elId = generateShortId();
      service.enqueueImage({ queueID: elId, file });
    });
    editor.undo.saveStep();
    return false;
  }

  setTimeout(() => {
    const target = editor.selection.get().anchorNode;
    if (target.nextSibling === null) {
      const blankParagraph = document.createElement('p');
      const breakLine = document.createElement('BR');
      target.parentElement.appendChild(blankParagraph);
      blankParagraph.appendChild(breakLine);
      blankParagraph.id = generateShortId();
    }
    // Focus at the current position.
    editor.markers.insertAtPoint(dropEvent.originalEvent);
    const $marker = editor.$el.find('.fr-marker');
    $marker.replaceWith($.FroalaEditor.MARKERS);
    editor.selection.restore();
    // Save into undo stack the current position.
    if (!editor.undo.canDo()) {
      editor.undo.saveStep();
    }
  }, 0);

  let dropData = dropEvent.originalEvent.dataTransfer.getData('text/plain');
  if (dropData) {
    try {
      dropData = JSON.parse(dropData);
    } catch (error) {
      console.warn('Invalid drop data.');
    }
  }

  if (dropData && dropData.type === EmbeddedType.YouTube) {
    editor.commands.exec('youtubeInsertViaHotkey');
  }

  if (dropData && dropData.type === EmbeddedType.Brightcove) {
    editor.commands.exec('brightcoveVideoInsertViaHotkey');
  }

  if (dropData && dropData.type === EmbeddedType.BrightcovePlaylist) {
    editor.commands.exec('brightcovePlaylistInsertViaHotkey');
  }

  if (dropData && dropData.type === EmbeddedType.FacebookPost) {
    editor.commands.exec('facebookPostInsertViaHotkey');
  }

  if (dropData && dropData.type === EmbeddedType.TwitterPost) {
    editor.commands.exec('twitterPostInsertViaHotkey');
  }

  if (dropData && dropData.type === 'image') {
    insertImageFromGM(editor, dropData);
  }

  if (dropData && dropData.type === EmbeddedType.Image) {
    editor.commands.exec('insertImage');
  }

  if (dropData && dropData.type === EmbeddedType.Gallery) {
    editor.commands.exec('insertGallery');
  }

  if (dropData && dropData.type === EmbeddedType.File) {
    editor.commands.exec('insertFile');
  }

  // Save into undo stack the changes.
  editor.undo.saveStep();

  // Stop event propagation.
  return false;
}

export function embedAnchorLink(contextComponent) {
  const anchorIconUrl = theme === 'default' ? './assets/img/anchor-link.svg' : './assets/img/anchor-link-dark.svg';
  $.FroalaEditor.DefineIconTemplate('far', '<mat-icon class="mat-icon froala far fa-[NAME]"></mat-icon>');

  $.FroalaEditor.DefineIcon('articleAnchorIcon', { NAME: 'link', ALT: 'Article Anchor Link', template: 'far' });

  $.FroalaEditor.RegisterCommand('insertAnchorLink', {
    title: 'Embed Article Anchor Link',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    icon: 'articleAnchorIcon',
    callback: function () { contextComponent.embedContent({ embedType: EmbeddedType.AnchorLink }) }
  });
}

export function addRelLink() {
  const options = {
    alternate: 'Alternate',
    author: 'Author',
    button: 'Button',
    external: 'External',
    follow: 'Follow',
    help: 'Help',
    license: 'License',
    nofollow: 'Nofollow',
    noncommercial: 'Noncommercial',
    sponsored: 'Sponsored',
    ugc: 'UGC',
    noopener: 'Noopener',
    noreferrer: 'Noreferrer',
  };

  $.FroalaEditor.DefineIconTemplate('rel', '<i class="far fa-[NAME] link-rel-icon"></i>');
  // Define Icon
  $.FroalaEditor.DefineIcon('addRel', { NAME: 'route', template: 'rel' });
  $.FroalaEditor.RegisterCommand('addRel', {
    title: 'Add relationship attribute',
    type: 'dropdown',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    options: options,
    html: function () {
      let html = '<ul class="fr-dropdown-list" role="presentation">';
      html += `${Object.entries(options).map((item,index) => {
        return `<li role="presentation">
          <a class="fr-command gd-addRel-custom-button" tabIndex="-1" role="option" data-cmd="addRel" data-param1="${item[0]}">
            <input type="checkbox" id=${item[0]} name="${item[0]}">
            <label for="${item[0]}">${item[1]}</label>
          </a>
        </li>`
      })}`;
      html = html.replace(/,/g, '');
      html += '</ul>';
      return html;
    },
    refreshOnShow: function ($btn, $dropdown) {
      const selection = this.selection.element();
      $btn.addClass('add-relationship-button-active');
      const inputList = $dropdown.find('input');
      const ulList = $dropdown.find('li');

      inputList.off('click').on('click', function() {
        const value = $(this).attr('name');
        const selectedRel = selection.getAttribute('rel');
        const selectedRelArr = selectedRel ? selectedRel.split(/[ ,-]+/) : [];
        const saveBtn = document.getElementsByClassName('gd-list-actions__button')[1] as HTMLInputElement;
        saveBtn.classList.remove('--disabled', 'mat-mdc-button-disabled', 'mat-mdc-button-disabled-interactive');

        if (selection) {
          if (!selectedRelArr.includes(value)) {
            const selectedRelStr = selectedRelArr && selectedRelArr.join(' ');
            const updateRelVal = value + " " + selectedRelStr;
            selection.setAttribute('rel', updateRelVal.trim());
          } else {
            const filterSelectedRelArr = selectedRelArr.filter(rel => rel !== value);
            if(!filterSelectedRelArr.length){
              selection.removeAttribute('rel');
              return;
            }
            const updateRelVal = filterSelectedRelArr.join(' ');
            selection.setAttribute('rel', updateRelVal);
          }
        }
      });

      inputList.toArray().forEach((el, i) => {
        const selectedRel = selection.getAttribute('rel');
        const selectedRelArr = selectedRel && selectedRel.toLowerCase().split(/[ ,-]+/);
        if (selectedRelArr && selectedRelArr.includes(el?.attributes?.name?.value)) {
          $(ulList[i]).addClass('selected-rel');
          (document.getElementById(`${el?.attributes?.name?.value}`) as HTMLInputElement).checked = true;
        }else {
          $(ulList[i]).removeClass('selected-rel');
          (document.getElementById(`${el?.attributes?.name?.value}`) as HTMLInputElement).checked = false;
        }
      })

      if ($dropdown) {
        $dropdown.find('.fr-dropdown-list').on('mousedown', function (e) {
          if(e.target.className.includes('gd-addRel-custom-button')){
            e.stopPropagation();
          }
        });
      }
    }
  });

}

export function addTargetLink() {
  $.FroalaEditor.DefineIconTemplate('target', '<i class="fal fa-[NAME] link-target-icon"></i>');
  $.FroalaEditor.DefineIcon('addTarget', { NAME: 'bullseye', template: 'target' });
  $.FroalaEditor.RegisterCommand('addTarget', {
    title: 'Add target attribute',
    type: 'dropdown',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    options: {
      '': 'None',
      '_blank': 'Blank',
      'framename': 'Framename',
      '_parent': 'Parent',
      '_self': 'Self',
      '_top': 'Top',
    },
    callback: function (cmd, val) {
      const selection = this.selection.element();
      // TODO refactor, `updateHtmlLink` shows a way of simpler rel attr management
      if (cmd === 'addTarget' && selection) {
        if (val) {
          // add 'noopener' and 'noreferrer' on rel if missing
          // prevent exploitation of the window.opener API
          const requiredRel = ['noopener', 'noreferrer'];
          requiredRel.forEach(v => {
            const selectedRel = selection.getAttribute('rel');
            const selectedRelArr = selectedRel ? selectedRel.split(/[ ,-]+/) : [];
            if (!selectedRelArr.includes(v)) {
              const selectedRelStr = selectedRelArr && selectedRelArr.join(' ');
              const updateRelVal = v + " " + selectedRelStr;
              selection.setAttribute('rel', updateRelVal.trim());
            }
          })
          selection.setAttribute('target', val)
        } else {
          selection.removeAttribute('target');
          const selectedRel = selection.getAttribute('rel');
          const selectedRelArr = selectedRel ? selectedRel.split(/[ ,-]+/) : [];
          const rel = selectedRelArr.filter(v => v != "noreferrer" && v != "noopener");

          if(!rel.length) {
            selection.removeAttribute('rel');
            return;
          }

          selection.setAttribute('rel', rel.join(' '));
        }
      }
    },
    refreshOnShow: function ($btn, $dropdown) {
      const selection = this.selection.element();
      const ulList = $dropdown.find('li');
      const anchorList = $dropdown.find('A');
      anchorList.toArray().forEach((el, i) => {
        const selectedTarget = selection.getAttribute('target');
        const selectedTargetFormat = selectedTarget && selectedTarget.replace(/^_+/, '');
        const elTarget = el.getAttribute('title');
        if (!selectedTarget) {
          $(ulList[0]).addClass('selected-target');
        }
        if (selectedTarget && elTarget.toLowerCase() === selectedTargetFormat.toLowerCase()) {
          $(ulList[0]).removeClass('selected-target');
          $(ulList[i]).addClass('selected-target');
        } else {
          $(ulList[i]).removeClass('selected-target');
        }
      });
    }
  });
}

export function updateHtmlLink(link: HTMLAnchorElement, linkText, href, target) {
  // set basic link content and href
  link.innerHTML = linkText;
  link.setAttribute('href', href);

  // update target and rel attributes
  const relAttribute: string[] = (link.getAttribute('rel') || '').split(' ').filter(r => !!r);
  const relAttributeSet = new Set(relAttribute);

  const addTargetAttribute = target && target !== '';
  if(addTargetAttribute) {
    link.setAttribute('target', target);
    relAttributeSet.add('noreferrer');
    relAttributeSet.add('noopener');
    const newRelAttribute = Array.from(relAttributeSet).join(' ');
    link.setAttribute('rel', newRelAttribute);
    return;
  }

  // removing target attribute
  link.removeAttribute('target');
  // when removing target attribute, we also take off
  // the noreferrer and noopener, and remove the rel attribute completely
  // if it has no other values
  relAttributeSet.delete('noreferrer');
  relAttributeSet.delete('noopener');
  if(relAttributeSet.size === 0) {
    link.removeAttribute('rel');
    return;
  }
  const newRelAttribute = Array.from(relAttributeSet).join(' ');
  link.setAttribute('rel', newRelAttribute);
}


export function addEmbedTikTokPost(contextComponent) {
  // Define Icon
  $.FroalaEditor.DefineIcon('tiktok', { NAME: 'tiktok', template: 'fab' });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('tiktok', {
    title: 'Embed TikTok Post',
    icon: 'tiktok',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { insertTikTokPostPlaceholder(this); }
  });

  function insertTikTokPostPlaceholder(editor, quick = false) {
    const elId = generateShortId();
    editor.image.insert('assets/img/tiktok-logo-dark.svg', true, {
      'quick': quick,
      'block-id': elId,
      'embed-type': EmbeddedType.TikTokPost,
    });
  }
}

export function addEmbedJWMedia(contextComponent) {
  $.FroalaEditor.DefineIconTemplate('jwIconTemplate', '<svg style="fill: currentColor; width: auto;" alt="JW Player logo" height="15px" viewBox="-1 -1 40 40" xmlns="http://www.w3.org/2000/svg">[PATH]</svg>')
  // Define Icon
  $.FroalaEditor.DefineIcon('jwIcon', { ALT: 'JW Media button', template: 'jwIconTemplate', PATH: customSvgJWPlayer });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('jwplayervideo', {
    title: 'Embed JW Player Video',
    icon: 'jwIcon',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { contextComponent.embedContent({ embedType: EmbeddedType.JWPlayerVideo }); }
  });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('jwplayerplaylist', {
    title: 'Embed JW Player Playlist',
    icon: 'jwIcon',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { contextComponent.embedContent({ embedType: EmbeddedType.JWPlayerPlaylist }); }
  });
}

export function addEmbedDailymotionMedia(contextComponent) {
  $.FroalaEditor.DefineIconTemplate('fab', '<mat-icon class="mat-icon froala fab fa-[NAME]"></mat-icon>')
  // Define Icon
  $.FroalaEditor.DefineIcon('dailymotionIcon', { ALT: 'Dailymotion Media button', template: 'fab', NAME: 'dailymotion' });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('dailymotionVideo', {
    title: 'Embed Dailymotion Video',
    icon: 'dailymotionIcon',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { contextComponent.embedContent({ embedType: EmbeddedType.DailymotionVideo }); }
  });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('dailymotionPlaylist', {
    title: 'Embed Dailymotion Playlist',
    icon: 'dailymotionIcon',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { contextComponent.embedContent({ embedType: EmbeddedType.DailymotionPlaylist }); }
  });
}


export function curlyQuote(contextComponent) {
  $.FroalaEditor.DefineIconTemplate(
    'fas',
    '<mat-icon class="mat-icon froala fas fa-[NAME]"></mat-icon>'
  );
  // Define Icon
  $.FroalaEditor.DefineIcon('curlyQuote', {
    NAME: 'quote-left',
    ALT: 'Curly Quote button',
    template: 'fas',
  });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('curlyQuote', {
    title: 'Convert Quotes To Curly',
    icon: 'curlyQuote',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () {
      contextComponent.curlyQuote(this);
    },
  });
}

export function blockQuote() {
  $.FroalaEditor.DefineIconTemplate(
    'fas',
    '<mat-icon class="mat-icon froala fas fa-[NAME]"></mat-icon>'
  );
  // Define Icon
  $.FroalaEditor.DefineIcon('blockQuote', {
    NAME: 'angle-double-right',
    ALT: 'Block Quote',
    template: 'fas',
  });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('blockQuote', {
    title: 'Block Quote',
    icon: 'blockQuote',
    focus: true,
    type:'dropdown',
    undo: true,
    refreshAfterCallback: true,
    options:{
      Increase: 'Increase',
      Decrease: 'Decrease'
    },
    callback: function (cmd, opt) {
      if(opt=== 'Increase'){
        this.quote.apply('increase');
      }
      else {
        this.quote.apply('decrease');
      }
    },
  });
}

export function createEditorPreferencesToolbarOption(contextComponent, cmd = null) {
  cmd = cmd || 'editorPreferences';
  $.FroalaEditor.DefineIcon(cmd, { NAME: 'user-cog', SVG_KEY: 'cogs' });
  $.FroalaEditor.RegisterCommand(cmd, {
    title: 'Preferences',
    type: 'dropdown',
    focus: false,
    undo: false,
    refreshAfterCallback: true,
    options: {},
    html: function () {
      var c = '<ul class="fr-dropdown-list" id="fr-editor-preferences" role="presentation">';

      // add smart quotes option
      c += `<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="${cmd}" data-param1="smartQuotesEnabled"><input type="checkbox">Use smart quotes</a></li>`;

      c += '</ul>';
      return c;
    },
    callback: function (cmd, val) {
      if (val === 'smartQuotesEnabled') {
        contextComponent.handleSmartQuotesSettingChange(!contextComponent.smartQuotesEnabled);
      }
    },
    // Callback on refresh.
    refresh: function ($btn) {
    },
    // Callback on dropdown show.
    refreshOnShow: function ($btn, $dropdown) {
      // update the state of smartQuotes checkbox
      const sqInput = $dropdown.find('.fr-command[data-param1="smartQuotesEnabled"] input[type="checkbox"]');
      if (sqInput) {
        sqInput.attr('checked', contextComponent.smartQuotesEnabled || false);
      }
    }
  });
}

export function addEmbedTwitchMedia(contextComponent) {
  $.FroalaEditor.DefineIconTemplate('fab', '<mat-icon class="mat-icon froala fab fa-[NAME]"></mat-icon>')
  // Define Icon
  $.FroalaEditor.DefineIcon('twitchIcon', { ALT: 'Twitch Media button', template: 'fab', NAME: 'twitch' });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('twitchVideo', {
    title: 'Embed Twitch Video',
    icon: 'twitchIcon',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { contextComponent.embedContent({ embedType: EmbeddedType.TwitchVideo }); }
  });

  // Define command to be executed from the toolbar
  $.FroalaEditor.RegisterCommand('twitchStream', {
    title: 'Embed Twitch Stream',
    icon: 'twitchIcon',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () { contextComponent.embedContent({ embedType: EmbeddedType.TwitchStream }); }
  });
}

// Note: notes mode should perhaps be available only to the editors?
const froalaToolbarButtons = [
  'bold', 'italic', 'underline', 'strikeThrough', 'fontFamily', 'fontSize', 'color',
  'align', 'formatOL', 'formatUL', 'indent', 'outdent', 'subscript', 'superscript', 'notes', '|',
  'paragraphFormat', 'paragraphStyle', 'blockQuote', 'curlyQuote', '|',
  'insertLink', 'insertTable', 'specialCharacters', 'insertHR', '|',
  // 'formatUL', 'insertTable', '|', // UL and Tables
  'clearFormatting', 'stripTags', 'clearTextEditor', '|', 'emoticons', '|',
  'undo', 'redo', '|',
  // custom embed controls
  'insertImage', 'insertGallery', 'insertFile', 'youtube', 'brightcove', 'brightcovePlaylist', 'vimeo',
  'jwplayervideo', 'jwplayerplaylist', 'dailymotionVideo', 'dailymotionPlaylist', 'twitchVideo', 'twitchStream',
  'facebook', 'twitter', 'instagram',
  'tiktok', 'insertAnchorLink', 'imageUrl', /*'embedly',*/
  '|', 'insertContentPanel', 'insertContentTag', 'closeContentTag', '|', 'systemWidget', 'thirdPartyWidget', '|',
  // RTL
  'rightToLeft', 'leftToRight', '|',
  // misc
  'help', 'html', 'fullscreen', 'editorPreferences'
];

const helpSets = [
  {
    title: 'Common actions',
    commands: [
      { val: 'OSkeyC', desc: 'Copy' },
      { val: 'OSkeyX', desc: 'Cut' },
      { val: 'OSkeyV', desc: 'Paste' },
      { val: 'OSkeyZ', desc: 'Undo' },
      { val: 'OSkeyShift+Z', desc: 'Redo' },
      { val: 'OSkeyK', desc: 'Insert Link' },
      { val: 'OSkeyP', desc: 'Insert Image' }
    ]
  },
  {
    title: 'Basic Formatting',
    commands: [
      { val: 'OSkeyA', desc: 'Select All' },
      { val: 'OSkeyB', desc: 'Bold' },
      { val: 'OSkeyI', desc: 'Italic' },
      { val: 'OSkeyU', desc: 'Underline' },
      { val: 'OSkeyS', desc: 'Strikethrough' },
      { val: 'OSkey]', desc: 'Increase Indent' },
      { val: 'OSkey[', desc: 'Decrease Indent' }
    ]
  },
  {
    title: 'Block Quote',
    commands: [
      { val: 'OSkey\'', desc: 'Increase block quote level' },
      { val: 'OSkeyShift+\'', desc: 'Decrease block quote level' }
    ]
  },
  {
    title: 'Table',
    commands: [
      { val: 'Alt+Space', desc: 'Select table cell' },
      { val: 'Shift+Left/Right arrow', desc: 'Extend selection one cell' },
      { val: 'Shift+Up/Down arrow', desc: 'Extend selection one row' }
    ]
  },
  {
    title: 'Navigation',
    commands: [
      { val: 'OSkey/', desc: 'Shortcuts' },
      { val: 'Alt+F10', desc: 'Focus popup / toolbar' },
      { val: 'Esc', desc: 'Return focus to previous position' }
    ]
  },
  {
    title: 'Embedded Content',
    commands: [
      { val: 'OSkeyY', desc: 'Embed YouTube Video' },
    ]
  }
];

export const FROALA_CONFIG = {
  language: '',
  direction: 'ltr',
  key: environment.froalaKey,
  iconsTemplate: 'font_awesome_5',
  imageDefaultDisplay: 'block',
  imageSplitHTML: true,
  imageUpload: false,
  imageEditButtons: ['imageAlign', 'editEmbed', 'imageDisplay', 'imageRemove'],
  quickInsertButtons: ['quickInsertImage', 'quickInsertGallery', 'quickInsertFile', 'quickInsertYouTube', 'quickInsertArticleLink', 'quickInsertTaxonomyLink', 'quickInsertBrightcove', 'quickInsertVimeo'],
  toolbarButtons: froalaToolbarButtons,
  toolbarButtonsMD: froalaToolbarButtons,
  toolbarButtonsSM: froalaToolbarButtons,
  toolbarButtonsXS: froalaToolbarButtons,
  scrollableContainer: '.main-container',
  heightMin: 550,
  imageDefaultWidth: 0,
  helpSets: helpSets,
  shortcutsEnabled: [
    'show', 'bold', 'italic', 'underline', 'strikeThrough',
    'indent', 'outdent', 'undo', 'redo', 'insertImage', 'insertLink', 'help', 'insertAnchorLink'
  ],
  linkInsertButtons: ['linkBack'],
  linkEditButtons: ['linkOpen', 'linkEdit', 'addRel', 'addTarget', 'linkRemove'],
  lineBreakerOffset: 20,
  imageResize: false,
  //! PROTOTYPE CODE
  // here we add the `editor-widget-card-frame` HTML tag as valid Froala element
  lineBreakerTags: ['p.fr-embedded', 'div.fr-embedly', 'section', '.gd-helper-element', 'editor-widget-card-frame'],
  htmlAllowedAttrs: [...$.FroalaEditor.DEFAULTS.htmlAllowedAttrs, 'nodeId', 'usage'],
  htmlAllowedEmptyTags: [...$.FroalaEditor.DEFAULTS.htmlAllowedEmptyTags, 'editor-widget-card-frame'],
  htmlAllowedTags: [...$.FroalaEditor.DEFAULTS.htmlAllowedTags, 'gd-editor-note', 'editor-widget-card-frame'],
  pasteDeniedAttrs: ['style', 'id', 'class'],
  fontSize: ['8', '9', '10', '11', '12', '14', '16', '18', '20', '22', '24', '26', '28', '30', '36', '48', '60', '72', '96'],
  charCounterCount: false,
  paragraphFormat: { N: 'Normal', H1: 'Heading 1', H2: 'Heading 2', H3: 'Heading 3', H4: 'Heading 4', H5: 'Heading 5', PRE: 'Code' },
  tableEditButtons: [
    'tableHeaderCell',
    'tableHeader',
    'tableRemove',
    '|',
    'tableRows',
    'tableColumns',
    'tableStyle',
    '-',
    'tableCells',
    'tableCellBackground',
    'tableCellVerticalAlign',
    'tableCellHorizontalAlign',
    'tableCellStyle'
  ],
  emoticonsUseImage: false,
  emoticonsStep: 8,
  emoticonsSet: getStaticProcessedEmoticons(),
  dragInline: false,
  placeholderText: '',
};

function getChosenTheme() {
  const localStorage = Object.values(window.localStorage);
  let theme = "default"
  Object.keys(localStorage).forEach(item => {
    try {
      const obj = JSON.parse(localStorage[item])
      if (obj && obj.theme) {
        return theme = obj.theme;
      }
    } catch(e) {}
  });
  return theme;
}
